// useLiveListContext — widget-side hook that tracks the latest live listing
// state published by the office grids (via the window page-context bus).
//
// The widget overlays this onto the server-rendered page context at send time
// so IPA sees the user's CURRENT filters/sort/page/count/visible rows rather
// than the stale snapshot computed at HTML render (before the grid loaded).
import { useEffect, useState } from 'react';
import { subscribeListContext } from '../services/pageContextBus';
export function useLiveListContext() {
    const [listContext, setListContext] = useState(null);
    useEffect(() => {
        // subscribeListContext replays the current value synchronously, then
        // updates on every publish. Returns an unsubscribe.
        return subscribeListContext(setListContext);
    }, []);
    return listContext;
}
